import { WeaponGroup } from '@api/disciplinesApi/interfaces';
import { Item } from '@components/badges/BadgeList/interfaces';
import i18n from '@translations/i18n';
import type { TFunction } from 'i18next';

export const ORDERED_WEAPON_GROUPS: WeaponGroup[] = [
  'lp',
  'lg',
  'kkp',
  'kkg',
  'gkp',
  'gkg',
  'hwg',
  'hwp',
  'hwkan',
  'hwklei',
  'klei',
  'biat',
];

export const getWeaponGroupShortLabel = (group: WeaponGroup): string =>
  group.toUpperCase();

export const mapWeaponGroupsToDetailBadgeItems = (
  weaponGroups: WeaponGroup[],
  t: TFunction
): Item[] =>
  weaponGroups.map((group) => ({
    label: getWeaponGroupShortLabel(group),
    tooltip: t(`competitions:weaponGroups.${group}.label`),
  }));

export const mapWeaponGroupsToBadgeItems = (
  weaponGroups: WeaponGroup[]
): Item[] => mapWeaponGroupsToDetailBadgeItems(weaponGroups, i18n.t);

export const sortWeaponGroups = (weaponGroups: WeaponGroup[]): WeaponGroup[] => {
  const allowed = new Set(weaponGroups);

  return ORDERED_WEAPON_GROUPS.filter((group) => allowed.has(group));
};
